<template>
  <v-menu
    offset-y
    v-if="notifications.length>0"
    left
    origin="right top"
    z-index="99"
    content-class="notification-dropdown"
    transition="slide-y-transition"
    nudge-top="-10"
  >
    <v-btn class="notification-icon ml-2 mr-2" icon slot="activator">
      <v-badge right color="transparent">
        <v-icon color="primary">notifications_none</v-icon>
        <span slot="default" class="text-secondary ml-1">{{notifications.length}}</span>
      </v-badge>
    </v-btn>
    <div class="dropdown-content">
      <div class="dropdown-top d-custom-flex justify-space-between primary">
        <span class="white--text fw-bold">{{$t('message.notifications')}}</span>
      </div>
      <v-list class="dropdown-list">
        <v-list-tile
          class="height-max-content"
          v-for="(notification, index) in notifications"
          :key="notification.payload"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{notification.title}}</v-list-tile-title>
            <v-list-tile-sub-title class="text--primary">{{ notification.body }}</v-list-tile-sub-title>
            <v-flex class="w-100 text-xs-right">
              <v-icon small @click="remove(index)" color="accent">delete</v-icon>
            </v-flex>
            <v-flex class="w-100 text-xs-center" v-if="notification.payload">
              <a :href="notification.payload" target="_blank">
                <img v-bind:src="notification.payload" class="img-ajust-width" align="center">
              </a>
            </v-flex>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import GNSService from "@/common/util/GNSService";
import { textTruncate } from "@/common/helpers/helpers";
import { i18n } from "@/main";

export default {
  computed: {
    ...mapGetters(["userIdIAM","userScopes"])
  },
  mounted() {      
    this.$nextTick(()=>{     
    GNSService.connect("web aps.aseguradoradelsur."+(process.env['VUE_APP_ENVIRONMENT']||'com')+"_" + this.userIdIAM.uid).finally(()=>{
        GNSService.subscribe("news","web aps.aseguradoradelsur."+(process.env['VUE_APP_ENVIRONMENT']||'com')+"_" + this.userIdIAM.uid);
        GNSService.notification((data)=>{
          //console.log(data)
             if(!this.containsObject(data,this.notifications)){
             this.notifications.push(data);
             }
        })
    })
    })
  },
  methods: {
    textTruncate(text) {
      return textTruncate(text, 25);
    },
    remove(index) {
      this.$confirm(i18n.t("message.confirmRemoveNotification"), {
        title: "Eliminar"
      }).then(res => {
        if (res) {
          this.notifications.splice(index, 1);
        }
      });
    },
    containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
        if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
            return true;
        }
    }
    return false;
}
  },
  data() {
    return {
      notifications: []
    };
  }
};
</script>
